import { DataTable, Dialog } from "@/components";
import useTaskAssignment from "./useMyTasks";
import { Button } from "@/components/ui";
import { SummaryCard } from "./SummaryCard";
import { filter } from "@/assets";
import { Filter } from "./Filter";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const MyTasks = () => {
  const {
    columns,
    onAdd,
    openDeleteDialog,
    setOpenDeleteDialog,
    onConfirmDelete,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
    isLoading,
    error,
    isDeleting,
    summaryCardData,
    isCountsLoading,
  } = useTaskAssignment();

  const { id } = useParams();
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // Backend sends role as array, e.g. ["CRM_HEAD"]
  const roles = loggedInUserData?.role || [];
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  // ✅ Show summary cards only if id is present OR role is CRM_HEAD
 

  return (
    <div className="relative">
      {/* Header Buttons */}
      <div className="mb-4 px-5 flex justify-end lg:absolute lg:-top-15 lg:right-0 gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} alt="Filter" />
          Filter
        </Button>
      </div>

      {/* ✅ Conditional Summary Cards */}
      {!id && (
        <div className="px-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 pb-5">
          {isCountsLoading ? (
            <div>Loading task status counts...</div>
          ) : (
            summaryCardData?.map((data: any, index: number) => (
              <SummaryCard key={index} {...data} />
            ))
          )}
        </div>
      )}

      {/* Table Section */}
      {isLoading && <div>Loading...</div>}
      {error && <div>Error: {error.message}</div>}
      {!isLoading && !error && (
        <DataTable
          columns={columns}
          data={tableData}
          serviceSidePagination={true}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}

      {/* Delete Confirmation Dialog */}
      {openDeleteDialog && (
        <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title="Delete Task Assignment"
          onSave={onConfirmDelete}
          saveText="Delete"
          saveBtnClassName="bg-red-600 hover:bg-red-500"
          isLoading={isDeleting}
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to delete this task assignment?</p>
          </div>
        </Dialog>
      )}

      {/* Filter Drawer */}
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </div>
  );
};

export default MyTasks;
